/**
 * 判断是否是小屏幕设备
 * @returns {Boolean}
 */
export function isMobile() {
  return /Android|WindowsPhone|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent);
}
